export const comments_3787343 = {"data":{"data":[],"links":{}}}